import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import VueTheMask from 'vue-the-mask'
import Toast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";
import '../src/main.css'

loadFonts()

createApp(App)
  .use(router)
  .use(vuetify)
  .use(VueTheMask)
  .use(Toast)
  .mount('#app')
